import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const actividades = ['Juan de Córdoba accedió al Pack Taller Blindado', 'Mateo de Buenos Aires accedió al Pack Taller Blindado', 'Pablo de Rosario accedió al Pack Taller Blindado', 'Sergio de Mendoza accedió al Pack Taller Blindado', 'Nicolás de La Plata accedió al Pack Taller Blindado', 'Facundo de Mar del Plata accedió al Pack Taller Blindado', 'Leandro de Tucumán accedió al Pack Taller Blindado', 'Gustavo de Salta accedió al Pack Taller Blindado', 'Ramiro de Santa Fe accedió al Pack Taller Blindado', 'Agustín de Neuquén accedió al Pack Taller Blindado'];
// Fisher-Yates shuffle
function shuffleArray(array: string[]) {
  const newArr = [...array];
  for (let i = newArr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [newArr[i], newArr[j]] = [newArr[j], newArr[i]];
  }
  return newArr;
}
export function ActivityPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [message, setMessage] = useState('');
  const [shuffledActivities, setShuffledActivities] = useState<string[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    setShuffledActivities(shuffleArray(actividades));
  }, []);
  useEffect(() => {
    if (shuffledActivities.length === 0) return;
    let showTimeout: NodeJS.Timeout;
    let hideTimeout: NodeJS.Timeout;
    const scheduleNext = () => {
      // Wait between 40s and 60s for next popup
      const nextDelay = 40000 + Math.random() * 20000;
      showTimeout = setTimeout(showPopup, nextDelay);
    };
    const showPopup = () => {
      setMessage(shuffledActivities[currentIndex % shuffledActivities.length]);
      setCurrentIndex(prev => prev + 1);
      setIsVisible(true);
      // Hide after 5 seconds
      hideTimeout = setTimeout(() => {
        setIsVisible(false);
        scheduleNext();
      }, 5000);
    };
    // Initial delay between 8s and 15s
    const initialDelay = 8000 + Math.random() * 7000;
    showTimeout = setTimeout(showPopup, initialDelay);
    return () => {
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
    };
  }, [shuffledActivities, currentIndex]);
  const handleClose = () => {
    setIsVisible(false);
  };
  return <AnimatePresence data-id="element-16">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 16
    }} transition={{
      duration: 0.4
    }} className="fixed bottom-6 left-6 z-[9999] bg-mc-gray border-2 border-mc-yellow rounded-xl p-3 max-w-[300px] flex items-center gap-3 shadow-[0_8px_32px_rgba(0,0,0,0.6)]" data-id="element-17">
          <button onClick={handleClose} className="absolute top-1.5 right-2 bg-transparent border-none text-mc-gray3 cursor-pointer text-[0.9rem] hover:text-white transition-colors" aria-label="Cerrar" data-id="element-18">
            ✕
          </button>
          <div className="bg-mc-yellow text-mc-dark rounded-full w-[38px] h-[38px] flex items-center justify-center text-[1.2rem] shrink-0" data-id="element-19">
            🛡️
          </div>
          <div data-id="element-20">
            <div className="text-[0.68rem] text-mc-yellow font-bold uppercase tracking-widest mb-0.5" data-id="element-21">
              Actividad reciente
            </div>
            <div className="text-[0.82rem] text-gray-200 font-semibold leading-[1.4]" data-id="element-22">
              {message}
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}